import { z } from 'zod/v4';

import { AdvancedTQLFilterDTO } from './advanced-filter';
import { TreeSettingsSchemaDTO } from '@/shared/lib/utils/tree/schema';
import { CIDTO } from '@/entities/srm/ci/@x/tql-query';
import { TQLFilterDTO } from './query';

/** TreeExportRequestDTO */
export const TreeExportRequestDTO = z.object({
  query: TQLFilterDTO,
  tree_settings: z.array(TreeSettingsSchemaDTO),
});
export type TreeExportRequest = z.infer<typeof TreeExportRequestDTO>;

/** TreeRequestDTO */
export const TreeRequestDTO = z.object({
  filter: TQLFilterDTO.optional(),
  tree_settings: z.array(TreeSettingsSchemaDTO),
});
export type TreeRequest = z.infer<typeof TreeRequestDTO>;

/** TreeQueryIDDTO */
export const TreeQueryIDDTO = z.object({
  query_id: z.string(),
  tree_settings: z.array(TreeSettingsSchemaDTO),
  advanced_tql_params: AdvancedTQLFilterDTO,
});
export type TreeQueryID = z.infer<typeof TreeQueryIDDTO>;

/** TreeItemDTO */
export const TreeItemDTO = CIDTO.pick({
  ci_type_name: true,
  ci_name: true,
}).extend({
  ci_id: z.string(),
  node_id: z.string(),
});
export type TreeItem = z.infer<typeof TreeItemDTO>;

/** TreeResponseDTO (recursive) */
export const TreeResponseDTO: z.ZodType<any> = z.lazy(() =>
  z.object({
    ci_name: z.string(),
    node_id: z.number().optional(),
    ci_type_name: z.string(),
    ci_id: z.string().optional(),
    children: z.array(TreeResponseDTO),
  }),
);
export type TreeResponse = z.infer<typeof TreeResponseDTO>;

/** TreeNodeDTO */
export const TreeNodeDTO = TreeItemDTO.extend({
  children: z.array(TreeItemDTO).default([]),
  missing_node: z.any().optional(),
});
export type TreeNode = z.infer<typeof TreeNodeDTO>;